import React, { useMemo, useState } from "react";
import SupplyingTable from "../Supplyings_table";
import { Switch, Spin, Modal, Checkbox } from "antd";
import { FaTrash, FaCheck, FaTimes } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import TextInputModal from "../../../../TextInputModal";
import {
  have_product_reference,
  supplyingCount,
} from "../../../../../../helpers/OrdersFunctionsGlobal";

import ChangeOrderRowPopover from "../ChangeOrderRowPopover";
import {
  returnEuroString,
  url_to_store_by_reference,
} from "../../../../../../helpers/Utils";
import ServiceRowChangesTable from "../../../../../ServicePage/Items/ServiceForms/service_row_changes_table";
import TooltipInfo from "../../../../TooltipInfo";
import {
  createHoomtask,
  updateOrderRowGoods,
} from "../../../../../../redux/Actions/orderAction";
import { useDispatch } from "react-redux";
import { IconDot } from "../../../../../Layout/Icons";
import ServiceDisplay from "./ServiceDisplay";
import { ImPriceTag } from "react-icons/im";
import { useSelector } from "react-redux";
import AntdConfirm from "../../../../../../helpers/AntdConfirm";

// Using Order, FakeOrder, Service
function OrderRowComponent({
  disabled = false,
  item,
  mode,
  orderId,
  updateSerialNumber,
  updateOrderRowGoods,
  deleteOrderRowGoods,
  deleteSupply,
  updateSupplying,
  store_url,
  order_rows,
}) {
  const dispatch = useDispatch();
  const [showRemove, setShowRemove] = React.useState(false);
  const [Loading, setLoading] = React.useState(false);
  const [EditBlock, setEditBlock] = React.useState(false);
  const [EditDetails, setEditDetails] = React.useState({
    quantity: item.quantity,
    price: item.unit_price_tax_incl,
  });

  const hoomtask_active = useMemo(() => {
    if (typeof item?.additional_info?.hoomtask?.success !== "boolean")
      return "hidden";
    return item?.additional_info?.hoomtask?.success || false;
  }, [item?.additional_info?.hoomtask?.success]);

  const editHandler = () => {
    setEditDetails({
      quantity: item.quantity,
      price: item.unit_price_tax_incl,
    });
    setEditBlock((prev) => !prev);
  };

  const editOrderRowGoodsFunc = () => {
    setLoading(true);
    const variables = {
      order_row: {
        quantity: EditDetails.quantity,
        product_price: EditDetails.price,
        unit_price_tax_incl: EditDetails.price,
        unit_price_tax_excl: EditDetails.price,
        manual: 1,
      },
    };
    updateOrderRowGoods(variables, orderId, item.id).then((res) => {
      if (res) {
        setLoading(false);
        setEditBlock(false);
      }
    });
  };
  const deleteOrderRowGoodsFunc = (orderId, itemID) => {
    setLoading(true);
    deleteOrderRowGoods(orderId, itemID).then((response) => {
      if (response.ok) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setEditDetails({
      ...EditDetails,
      [name]: value,
    });
  };

  if (Loading) {
    return (
      <thead
        onMouseEnter={() => setShowRemove(true)}
        onMouseLeave={() => setShowRemove(false)}
      >
        <tr>
          <th colSpan="4">
            {" "}
            <div className="d-flex align-items-center justify-content-center">
              <Spin size="small" />
            </div>
          </th>
        </tr>
      </thead>
    );
  }
  item.quantity = Number(item.quantity).toFixed(0);
  const serviceType = mode == "Servisas" || mode == "Servisas_Remontas";
  const supplying_count = supplyingCount(item.supplyings);
  const its_product = have_product_reference(item.product_reference);
  return (
    <React.Fragment>
      <thead
        onMouseEnter={() => setShowRemove(true)}
        onMouseLeave={() => setShowRemove(false)}
      >
        <tr>
          <td style={{ fontSize: "0.8rem" }}>
            {its_product ? (
              <>
                <a
                  className={`text-primary ${
                    item.manual ? "border-bottom border-danger" : ""
                  }`}
                  href={item?.product_url != '#' && item?.product_url ? item?.product_url : url_to_store_by_reference(
                    store_url,
                    item.product_reference
                  )}
                  target="_blank"
                >
                  {item.product_reference}
                </a>
                {item.order_cart_rule_id ? (
                  <ImPriceTag className={`text-success mr-1`} />
                ) : (
                  <div>
                    <AssigningDiscountOrderRow order_row={item} />
                  </div>
                )}
              </>
            ) : (
              <div className="text-center m-auto">
                {order_rows && (
                  <ServiceDisplay
                    parent_id={item.parent_id}
                    order_row_id={item.id}
                    order_rows={order_rows}
                    order_id={item.order_id}
                  />
                )}
              </div>
            )}
          </td>
          <td colSpan="4">
            <span style={{ fontSize: "0.8rem" }}>
              <span>
                {have_product_reference(item.product_reference) && (
                  <span
                    className={
                      item.shipments_count &&
                      item.shipments_count >= supplying_count
                        ? "text-success mr-1"
                        : "text-danger mr-1"
                    }
                  >
                    [S:{item.shipments_count}]
                  </span>
                )}
                <span
                  className={item.manual ? "border-bottom border-danger" : null}
                >
                  {item.product_name}
                </span>{" "}
              </span>
            </span>
          </td>
          <td>
            <small>{item.user_title || ""}</small>
          </td>
          {orderId && (
            <>
              {EditBlock ? (
                <React.Fragment>
                  <th style={{ fontSize: "0.8rem" }}>
                    <TextInputModal
                      // disabled={serviceType}
                      type="number"
                      placeholder="Quantity"
                      name="quantity"
                      onChange={(e) => onChange(e)}
                      value={EditDetails.quantity}
                    />
                  </th>
                  <td colSpan={2}>
                    <TextInputModal
                      type="number"
                      placeholder="Price"
                      name="price"
                      onChange={(e) => onChange(e)}
                      value={EditDetails.price}
                    />
                  </td>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {serviceType ? (
                    <td>{item.serial_number}</td>
                  ) : its_product ? (
                    <td>
                      {!disabled && (
                        <Switch
                          checkedChildren="S/N"
                          unCheckedChildren="S/N"
                          checked={item.required_serial_number}
                          disabled={
                            item.required_serial_number && item.serial_number
                          }
                          onChange={(e) => {
                            updateSerialNumber(orderId, item.id, {
                              order_row: {
                                serial_number: item.serial_number,
                                required_serial_number: e,
                              },
                            });
                          }}
                        />
                      )}
                    </td>
                  ) : (
                    <td></td>
                  )}

                  <td style={{ fontSize: "0.8rem" }}>{item.quantity}</td>
                  <td
                    style={{
                      float: "right",
                      whiteSpace: "nowrap",
                      fontSize: "0.8rem",
                    }}
                  >
                    {returnEuroString(item.unit_price_tax_incl)}
                  </td>
                </React.Fragment>
              )}
            </>
          )}
          <td>
            {orderId && !disabled && !item.returns_count && (
              <>
                {EditBlock ? (
                  <React.Fragment>
                    <div
                      className="d-flex align-items-center"
                      style={{ height: "35px" }}
                    >
                      <FaCheck
                        style={{
                          color: "green",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                        onClick={() => editOrderRowGoodsFunc()}
                      />
                      <FaTimes
                        style={{
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                        onClick={() => editHandler()}
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="d-flex-inline">
                      <MdEdit
                        style={{
                          color: "red",
                          cursor: "pointer",
                          visibility: showRemove ? "visible" : "hidden",
                          marginLeft: "10px",
                        }}
                        onClick={() => editHandler()}
                      />
                      {mode !== "Servisas" && item.shipments_count == 0 && (
                        <>
                          {item.supplyings.length == 0 &&
                            have_product_reference(item.product_reference) && (
                              <ChangeOrderRowPopover
                                item_id={item.id}
                                item_product_name={item.product_name}
                                item_product_price={item.product_price}
                                item_quantity={item.quantity}
                                order_id={item.order_id}
                                updateOrderRowGoods={updateOrderRowGoods}
                                showRemove={showRemove}
                              />
                            )}
                          <FaTrash
                            style={{
                              color: "orange",
                              cursor: "pointer",
                              visibility: showRemove ? "visible" : "hidden",
                              marginLeft: "10px",
                            }}
                            onClick={() =>
                              deleteOrderRowGoodsFunc(orderId, item.id)
                            }
                          />
                        </>
                      )}
                    </div>
                  </React.Fragment>
                )}
              </>
            )}
          </td>
        </tr>
        {have_product_reference(item.product_reference) &&
          item.product_info && (
            <tr>
              <td></td>
              <td colSpan={9} className="d-flex">
                {hoomtask_active !== "hidden" && (
                  <TooltipInfo
                    title={
                      <div>
                        {hoomtask_active ? (
                          "Active"
                        ) : (
                          <div
                            className="text-primary cursor-pointer text-decoration-underline"
                            onClick={() => {
                              dispatch(createHoomtask(orderId, item.id));
                            }}
                          >
                            Resend
                          </div>
                        )}
                      </div>
                    }
                  >
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="mr-1">HOOMTASK</div>
                      <IconDot
                        className={
                          hoomtask_active ? "text-success" : "text-danger"
                        }
                      />
                    </div>
                  </TooltipInfo>
                )}
                {item.product_info.ean && (
                  <TooltipInfo title={item.product_info.ean}>EAN</TooltipInfo>
                )}
                {item.product_info.barcodes?.length > 0 && (
                  <TooltipInfo title={item.product_info.barcodes.join(", ")}>
                    BAR
                  </TooltipInfo>
                )}
                {item.asin && (
                  <TooltipInfo title={item.asin}>
                    {item.amazon_url ? (
                    <a href={item.amazon_url} target="_blank" rel="noopener noreferrer">
                      ASIN
                    </a>
                    ) : (
                      "ASIN"
                    )}
                  </TooltipInfo>
                )}
                {item.supplier && (
                  <TooltipInfo title={item.supplier}>
                    SUPPLIER
                  </TooltipInfo>
                )}
              </td>
            </tr>
          )}
      </thead>
      {its_product &&
        order_rows &&
        order_rows
          .filter(
            (d) =>
              d.parent_id == item.id &&
              !have_product_reference(d.product_reference)
          )
          .map((child_or) => (
            <OrderRowComponent
              disabled={disabled}
              key={`child_order_row_${child_or.id}`}
              item={child_or}
              orderId={orderId}
              updateOrderRowGoods={updateOrderRowGoods}
              deleteOrderRowGoods={deleteOrderRowGoods}
              store_url={store_url}
              order_rows={order_rows}
            />
          ))}
      <tbody style={{ fontWeight: "400", backgroundColor: "#F4F4F4" }}>
        {item.supplyings &&
          item.supplyings.map((itemSup, i) => (
            <SupplyingTable
              disabled={disabled}
              mode={mode}
              key={i}
              item={itemSup}
              deleteSupply={deleteSupply}
              updateSupplying={updateSupplying}
              product_reference={item.product_reference}
              id_order_row={item.id}
              orderId={orderId}
            />
          ))}
        {serviceType &&
          item.service_row_changes &&
          item.service_row_changes.map((itemSup, i) => (
            <ServiceRowChangesTable key={i} item={itemSup} orderId={orderId} />
          ))}
      </tbody>
    </React.Fragment>
  );
}

export default OrderRowComponent;

const AssigningDiscountOrderRow = ({ order_row }) => {
  const [showModal, setShowModal] = useState(false);

  // TODO: cia
  const { order_cart_rules = [] } = useSelector((state) => state.orders);

  const filtered_order_cart_rules = useMemo(
    () =>
      order_cart_rules.filter((order_cart_rule) => {
        if (!!order_cart_rule.id_product) return false;
        if (order_row.unit_price_tax_incl <= +order_cart_rule.total)
          return false;
        return true;
      }),
    [order_cart_rules]
  );

  if (!filtered_order_cart_rules.length) return null;
  return (
    <>
      <ImPriceTag
        onClick={() => {
          setShowModal(true);
        }}
        className={`cursor-pointer text-danger mr-1`}
      />
      {showModal && (
        <ModalAssigningDiscountOrderRow
          order_cart_rule_id={order_row.order_cart_rule_id}
          order_row_id={order_row.id}
          order_cart_rules={filtered_order_cart_rules}
          order_id={order_row.order_id}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

const ModalAssigningDiscountOrderRow = ({
  order_cart_rule_id,
  order_row_id,
  order_cart_rules,
  order_id,
  onClose,
}) => {
  const dispatch = useDispatch();
  const [orderCartRuleId, setOrderCartRuleId] = useState(
    order_cart_rule_id || null
  );
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      open={true}
      title={"Additionally assign service to product"}
      onOk={() =>
        AntdConfirm({
          onOk: async () => {
            try {
              if (loading) return;
              setLoading(true);
              await dispatch(
                updateOrderRowGoods(
                  {
                    order_row: {
                      order_cart_rule_id: orderCartRuleId,
                    },
                  },
                  order_id,
                  order_row_id
                )
              );
              onClose();
            } finally {
              setLoading(false);
            }
          },
        })
      }
      onCancel={() => onClose()}
    >
      {order_cart_rules?.map(({ id, title, total }) => (
        <div
          className="my-1"
          key={id}
          style={{
            borderBottom:
              order_cart_rules.at(-1).id !== id ? "1px solid #DEE2E6" : "none",
          }}
        >
          <Checkbox
            checked={orderCartRuleId == id}
            onChange={() => {
              setOrderCartRuleId((prev) => (prev == id ? null : id));
            }}
          >
            {title} {returnEuroString(total)}
          </Checkbox>
        </div>
      ))}
    </Modal>
  );
};
